import { IAddressGlobal } from '../entities/IGlobal';
import { IOrganizationContext } from '../entities/IContext';
import { ETypeOfOrganization } from '../entities/IOrganization';

export enum ELegalEntityAddressValidationError {
    ADDRESS_MISSING = 'ADDRESS_MISSING',
    COUNTRY_MISSING = 'COUNTRY_MISSING',
    COUNTRY_INVALID = 'COUNTRY_INVALID'
}

const EXP_CTRL_TPRM_ORG_TYPES = new Set<ETypeOfOrganization>([
    ETypeOfOrganization.TPRM,
    ETypeOfOrganization.EXPORTCONTROL
]);

export const isExpCtrlOrTprmOrganization = (organization?: IOrganizationContext): boolean => {
    const orgType = organization?.details?.organizationType?.key;
    return !!orgType && EXP_CTRL_TPRM_ORG_TYPES.has(orgType);
};

/**
 * LE creation popup variant: mandatory structured address (country required).
 * Applies to ExpCtrl/TPRM workspaces when enabled at workspace level
 * (undefined defaults to enabled for backward-compatible rollout on those org types).
 */
export const isLegalEntityAddressMandatory = (organization?: IOrganizationContext): boolean => {
    if (!isExpCtrlOrTprmOrganization(organization)) {
        return false;
    }

    const workspaceSetting = organization?.details?.configuration?.requireLegalEntityAddressDuringCreation;
    if (workspaceSetting === false) {
        return false;
    }

    return true;
};

const getAddressCountryCode = (address?: IAddressGlobal): string =>
    (address?.countryShort || address?.CountryShort || '').trim();

export const validateLegalEntityCreationAddress = (
    address: IAddressGlobal | undefined,
    isMandatory: boolean
): ELegalEntityAddressValidationError | null => {
    if (!isMandatory) {
        return null;
    }

    if (!address) {
        return ELegalEntityAddressValidationError.ADDRESS_MISSING;
    }

    const countryCode = getAddressCountryCode(address);
    const countryName = (address.country || '').trim();

    if (!countryCode && !countryName) {
        return ELegalEntityAddressValidationError.COUNTRY_MISSING;
    }

    if (countryCode && !/^[A-Za-z]{2,3}$/.test(countryCode)) {
        return ELegalEntityAddressValidationError.COUNTRY_INVALID;
    }

    return null;
};
